import { CSSObjectWithLabel } from 'react-select';

import { colors } from '@atlaskit/theme';

type StateProps = {
  isFocused: boolean;
};

export const subtleSelector = (css: CSSObjectWithLabel, state: StateProps) => ({
  backgroundColor: state.isFocused ? css.backgroundColor : 'transparent',
  borderColor: state.isFocused ? css.borderColor : 'transparent',
});

export const nothingSelectedColor = () => ({
  color: colors.N400,
});
